import { SvgIcon as MuiSvgIcon, SvgIconProps as MuiSvgIconProps } from "@mui/material";

const ArrowLeftIcon = (props: MuiSvgIconProps) => (
  <MuiSvgIcon {...props} data-testid="arrow-left-icon">
    <mask id="mask0_13098_2390" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_13098_2390)">
      <path d="M9.95192 17.6538L4.2981 12L9.95192 6.34619L11.0057 7.43079L7.1865 11.25H19.7019V12.75H7.1865L11.0057 16.5692L9.95192 17.6538Z" fill="var(--gravx-color-neutral-on-light-grey-8)" />
    </g>
  </MuiSvgIcon>
);

export default ArrowLeftIcon;
